import { useEffect, useState } from 'react';
import { sharingApi } from '@/services/SharingApi';

export { SHARED_WITH_YOU_PATH } from './sharedItemLink';

/**
 * How many items are shared with this reader as a guest, asked once per page load — the sidebar line
 * and a guest's landing both read it. `null` until the answer arrives, and after a failure: a failed
 * read is not "nothing is shared", so it draws no line and redirects nobody.
 */
let asked: Promise<number | null> | null = null;

export function useSharedWithYouCount(): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    let current = true;
    asked ??= sharingApi
      .sharedWithMe()
      .then((answer) => answer.items.length)
      .catch(() => {
        asked = null;
        return null;
      });
    void asked.then((answer) => current && setCount(answer));
    return () => {
      current = false;
    };
  }, []);
  return count;
}
